<template>
  <div class="bg-gray-100 p-4">
    <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
      Export aanvragen
    </p>
    Lees voor het aanvragen van de export de
    <router-link
      :to="{
        name: 'ExportVoorwaarden'
      }"
      class="underline mb-2 text-mi-blue-500"
      >voorwaarden
    </router-link>
    voor het gebruik van de data.
    <FormulateForm
      class="login-form flex-col flex"
      @submit="submitExport"
      v-model="values"
    >
      <FormulateInput
        type="text"
        v-model="organisation"
        label="Organisatie"
        validation="required|max:250,length"
        wrapper-class="w-full lg:w-1/2"
        input-class="w-full h-8"
        :validation-messages="{
          required: 'Organisatie is verplicht; geef eventueel privé op.',
          max: 'Organisatie mag maximaal 250 tekens bevatten'
        }"
      />
      <FormulateInput
        type="textarea"
        v-model="reason"
        label="Reden van aanvraag"
        validation="required|max:250,length"
        wrapper-class="w-full lg:w-1/2"
        input-class="h-40"
        :validation-messages="{
          required: 'Reden is verplicht',
          max: 'Reden mag maximaal 250 tekens bevatten'
        }"
      />
      <FormulateInput
        v-model="accept_agreement"
        type="checkbox"
        label="Ik weet dat ik verplicht ben om bij elke uiting een bronvermelding naar de DSA te maken."
        wrapper-class="flex-row
      flex mt-2"
        validation="required"
        label-class="semi-bold mx-4"
        :validation-messages="{
          required:
            'Export kan alleen gedaan worden wanneer deze checkbox is aangevinkt.'
        }"
      />
      <FormulateInput
        v-model="may_contact"
        type="checkbox"
        wrapper-class="flex-row
      flex"
        validation="required"
        label-class="semi-bold mx-4"
        label="Ik weet dat het Mulier Instituut na een half jaar contact met me opneemt om na te gaan welke resultaten het gebruik van de DSA heeft opgeleverd."
        :validation-messages="{
          required:
            'Export kan alleen gedaan worden wanneer deze checkbox is aangevinkt.'
        }"
      />

      <FormulateInput
        type="submit"
        label="Exporteer"
        :disabled="!accept_agreement || !may_contact"
        class="mt-4"
        :class="{
          'opacity-50': !accept_agreement || !may_contact,
          'pointer-events-none': !accept_agreement || !may_contact
        }"
        input-class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
      />
    </FormulateForm>
    {{ error_msg }}
    {{ send_msg }}
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PublicExport",
  data() {
    return {
      values: {},
      postcode_error: true,
      reason: "",
      organisation: "",
      accept_agreement: false,
      may_contact: false,
      error_msg: null,
      send_msg: null
    };
  },
  computed: mapState({
    user: function() {
      return this.$store.getters.current_user;
    }
  }),

  methods: {
    submitExport: async function() {
      this.$store.dispatch("exportAccommodaties", {
        organisation: this.organisation,
        reason: this.reason
      });
      this.send_msg = `Uw downloadlink is verzonden naar ${this.user.email}. U wordt teruggeleid naar de zoekpagina.`;
    },
    sendHome: function() {
      this.$router.push({ name: "Home" });
    }
  },
  watch: {
    send_msg() {
      if (this.send_msg !== null) {
        setTimeout(this.sendHome, 5000);
      }
    }
  }
};
</script>

<style>
.formulate-form {
  @apply font-opensans;
}

.formulate-input-wrapper {
  @apply mb-2 grid grid-cols-2;
}

.formulate-input-element > textarea {
  @apply w-full;
}

.disabled {
  @apply appearance-none bg-transparent;
}

.editMode {
  @apply bg-transparent border-b border-gray-500 border-dashed;
}

.formulate-input-label {
  @apply font-bold;
}

.btn {
  @apply ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded;
}
.btn:hover {
  @apply bg-mi-blue-400 text-white border-transparent;
}

.btn.disabled {
  @apply hidden;
}
</style>
